import AppEventsBridge from './AppEventsBridge';

const EventBridge = new AppEventsBridge();

export default EventBridge;
